// START: color-values
// Green: 0,100,106
// Yellow: 255,214,0
// Red: 212,102,45
// Dark: 58,58,58
// END: color-values

import { getImageType } from './helpers';

const TYPE_TABLE = 'table';
const TYPE_TABLE_IMAGE = 'table_image';
const TYPE_NO_SECOND_PAGE = 'no_second';

// START: position-variables
const headerTextLeft = 15;
const headerFontSize = 20;
const headerLargeFontSize = 28;
const textWidth = 180;
const singleColumnTextWidthRatio = 1.6;
const endOfHero = 210;
const endOfMiddle = endOfHero + 150;
const startOfTable = endOfMiddle + 20;
const textAreaTop = endOfHero + 20;
const textAreaHeight = endOfMiddle + 40 - textAreaTop;
// END: position-variables

let pdfLocalizations = window.pdfLocalizations;
// Translations
if (!pdfLocalizations) {
	pdfLocalizations = {
		nutrientData: 'ravinnetiedot',
		productNumber: 'tuotenro:',
		pdfTitle: 'Tuotekortti',
		applicationProduct: 'Levitettävä tuote',
		roughMineral: 'Karkea kivennäismaa',
		mudMineral: 'Savinen kivennäismaa',
		sandMud: 'hieta-, hiue- ja hiesusavi',
		trueMud: 'Aitosavi',
		mulch: 'Multamaa, turvemaa, liejusavi',
		phExplanation:
			'Yhden viljavuusluokan (0,4 pH-yksikköä) kohottamiseen tarvittava kalkitusainemäärä tn/ha',
		footerStart: 'Tuotetietokortti',
		footerEnd: 'Tarkista aina viimeisimmät tuotetiedot osoitteesta: www.soilfood.fi',
	};
}

async function clickGeneratePDF(event) {
	let target;
	// Get the correct element, so we can access the right data stuff
	if (!event.target.classList.contains('btn-pdf')) {
		// event.path is not "standard", just chrome "standard", so we are using this to get the correct path
		const path = event.path || (event.composedPath && event.composedPath());
		target = path
			.filter((el) => {
				if (el.classList) {
					return el.classList.contains('btn-pdf');
				} else return false;
			})
			.shift();
	} else target = event.target;
	// We set up the default type of PDF here.
	let type = TYPE_NO_SECOND_PAGE;

	// We fetch all the data attributes from the pdf-button
	const title = target.getAttribute('data-title');
	const liftContent = target.getAttribute('data-lift-content');
	const number = target.getAttribute('data-number');
	const category = target.getAttribute('data-category');
	const image = target.getAttribute('data-image');
	const productData = target.getAttribute('data-product-data');
	const tableData = target.getAttribute('data-table-data');
	const tableImages = target.getAttribute('data-table-images');
	const language = target.getAttribute('data-product-language');
	const isFinnishSite = target.getAttribute('data-is-finnish-site') === '1';
	// We check for the availability of table data or images and set the type accordingly
	if (JSON.parse(tableData)) type = TYPE_TABLE;
	if (JSON.parse(tableImages).src !== false) type = TYPE_TABLE_IMAGE;
	await generatePDF(
		type,
		title,
		number,
		category,
		image,
		productData,
		tableData,
		tableImages,
		liftContent,
		language,
		isFinnishSite
	);
}

document.querySelectorAll('.btn-pdf').forEach((e) => e.addEventListener('click', clickGeneratePDF));

/**
 *
 * This functions programmatically builds the PDF.
 *
 * @param {string} type The type of PDF to generate, this drastically changes the PDF generation
 * @param {string} title The title of the product
 * @param {string} content The content of the product
 * @param {string} tuoteNro The product number
 * @param {string} category The category of the product
 * @param {string} tuoteImage The product image
 * @param {string} ravinneTiedot The nutrition table data
 * @param {string} vertailuTiedot The comparison table data
 * @param {string[]} tableImages The images of the table
 * @param {string} liftContent The content of the lift
 * @param {string} language The language of the PDF
 */
const generatePDF = async (
	type,
	title,
	tuoteNro,
	category,
	tuoteImage,
	ravinneTiedot,
	vertailuTiedot,
	tableImages,
	liftContent,
	language = 'fi',
	isFinnishSite = false
) => {
	const doc = new jspdf.jsPDF({
		format: 'a4',
		unit: 'px',
		putOnlyUsedFonts: true,
	});

	console.debug('Generating the pdf..');
	await header(doc, tuoteImage, title, category, tuoteNro, language);

	// START: middle area
	// START: Textarea - middle area
	doc.setTextColor(58, 58, 58);
	doc.setFont('AlbertSans', 'normal');
	const text = liftContent.length > 0 ? normalizeTextForPdf(strip(liftContent)) : '';
	const textLayout = getTextLayout(doc, text, textWidth, textAreaHeight);
	doc.setFontSize(textLayout.fontSize);
	doc.text(textLayout.firstColumn, 25, textAreaTop, {
		lineHeightFactor: textLayout.lineHeightFactor,
	});
	if (textLayout.secondColumn.length > 0) {
		doc.text(textLayout.secondColumn, textWidth + 60, textAreaTop, {
			lineHeightFactor: textLayout.lineHeightFactor,
		});
	}
	// END: Textarea - middle area

	// START: Yellow text divider - middle area (only when using two columns)
	if (textLayout.secondColumn.length > 0) {
		doc.setFillColor(255, 214, 0);
		doc.rect(textWidth + 38, endOfHero + 15, 1, 130, 'F');
	}
	// END Yellow text divider - middle area
	// END: middle area
	const parsedRavinneTiedot = JSON.parse(ravinneTiedot);
	if ((language === 'fi' || isFinnishSite) && parsedRavinneTiedot.length > 0) {
		// START: Table
		const startOfTableHeadings = startOfTable + 25;

		// START: Table Headings variables - table
		ravinneTiedot = JSON.parse(ravinneTiedot);
		const titles = ravinneTiedot.map((t) => t.name);
		const sizes = ravinneTiedot.map((t) => {
			return { content: t.size, styles: { fontSize: 6 } };
		});
		const data = ravinneTiedot.map((t) => t.value);
		// END: Table Headings variables - table

		// START: Header - table
		doc.setTextColor(58, 58, 58);
		doc.setFont('AlbertSans', 'normal');
		doc.setFontSize(14);
		// END: Header - table

		const tableHeight = titles.length > 10 ? 105 : 90;
		const tableHeadSize = titles.length > 12 ? (titles.length > 17 ? 7 : 8) : 10;

		// START: Table background - table
		doc.setFillColor(0, 100, 106);
		doc.rect(25, startOfTable, 390, tableHeight, 'F');
		// END: Table background - table

		// START: Table header - table
		doc.setTextColor(255, 255, 255);
		doc.writeText(0, startOfTable + 17, `${title} ${pdfLocalizations.nutrientData}`, {
			align: 'center',
		});
		// END: Table header - table

		// START: Table - table
		doc.autoTable({
			startY: startOfTableHeadings,
			head: [titles, sizes],
			body: [data],
			theme: 'plain',
			tableWidth: 370,
			margin: 35,
			styles: {
				font: 'AlbertSans',
				fontStyle: 'normal',
				halign: 'center',
				valign: 'middle',
				textColor: [255, 255, 255],
			},
			headStyles: {
				fontSize: tableHeadSize,
			},
			bodyStyles: {
				textColor: [58, 58, 58],
				fillColor: [255, 255, 255],
			},
		});
		// END: Table - table

		// START: Table footer - table
		// doc.setTextColor(255, 255, 255);
		// doc.setFont("ratio", "normal");
		// doc.setFontSize(10);
		// doc.text("Lähde:", 316, 585);
		// doc.setFont("ratio", "bold");
		// doc.text(`Soilfood Oy ${new Date().getFullYear()}`, 350, 585);
		// // END: Table footer - table
		// END: table
	}

	footer(doc);

	// NEXT PAGE

	/**
	 * Generates the table with an image
	 */
	async function generateTableImage() {
		doc.addPage();
		await header(doc, tuoteImage, title, category, tuoteNro, language);
		tableImages = JSON.parse(tableImages);
		let imagePosition = endOfHero + 20;
		for (const img of tableImages) {
			const image = document.createElement('img');
			image.src = img.src;
			const aspectRatio = calculateAspectRatioFit(img.width, img.height, 370, 370);
			// If the new image would be bigger than the page add a new page.
			if (aspectRatio.height + imagePosition > 560) {
				doc.addPage();
				await header(doc, tuoteImage, title, category, tuoteNro, language);
				footer(doc);
				imagePosition = endOfHero + 20;
			}
			const tableImageType = await getImageType(image);
			if (tableImageType !== false) {
				doc.addImage(
					image,
					tableImageType,
					35,
					imagePosition,
					aspectRatio.width,
					aspectRatio.height
				);
				imagePosition += aspectRatio.height + 20;
			}
		}
		footer(doc);
	}

	/**
	 * Generates the table
	 */
	async function generateTable() {
		doc.addPage();
		await header(doc, tuoteImage, title, category, tuoteNro, language);

		// Maps the data to row format
		const comparison = vertailuTiedot.map((v) => {
			let arrToReturn = [v.name];
			Object.values(v.data).forEach((d) => {
				if (typeof d === 'string') arrToReturn.push(d);
				else arrToReturn.push(...Object.values(d));
			});
			return arrToReturn;
		});
		const repeatValues = ['vm', 'm', 'rm', 'erm'];
		const headFirstRow = [
			pdfLocalizations.applicationProduct,
			{ content: pdfLocalizations.roughMineral, colSpan: 4 },
			{ content: pdfLocalizations.mudMineral, colSpan: 4 },
			{ content: pdfLocalizations.sandMud, colSpan: 4 },
			{ content: pdfLocalizations.trueMud, colSpan: 4 },
			pdfLocalizations.mulch,
		];
		const headSecondRow = [
			'',
			...repeatValues,
			...repeatValues,
			...repeatValues,
			...repeatValues,
			'',
		];

		doc.autoTable({
			startY: 220,
			head: [headFirstRow, headSecondRow],
			body: comparison,
			theme: 'plain',
			tableWidth: 370,
			margin: 35,
			rowPageBreak: 'avoid',
			styles: {
				font: 'AlbertSans',
				fontStyle: 'normal',
				fontSize: 8,
				halign: 'center',
				valign: 'middle',
				textColor: [255, 255, 255],
				fillColor: [0, 100, 106],
			},
			bodyStyles: {
				textColor: [58, 58, 58],
				fillColor: [255, 255, 255],
				lineColor: [0, 100, 106],
				overflow: 'linebreak',
			},
			didDrawCell: (data) => {
				doc.setDrawColor(0, 100, 106);
				if (data.column.index === 0) {
					doc.setLineWidth(10);
					doc.line(
						data.cell.x - 5,
						data.cell.y,
						data.cell.x - 5,
						data.cell.y + data.cell.height + 1.5
					);
				}
				if (data.column.index === headSecondRow.length - 1) {
					doc.setLineWidth(10);
					doc.line(
						data.cell.x + data.cell.width + 5,
						data.cell.y,
						data.cell.x + data.cell.width + 5,
						data.cell.y + data.cell.height + 1.5
					);
				}
				if (data.section === 'body') {
					doc.setLineWidth(3.5);
					doc.line(
						data.cell.x,
						data.cell.y + data.cell.height,
						data.cell.x + data.cell.width,
						data.cell.y + data.cell.height
					);
					if (data.column.index === headSecondRow.length - 1) {
						doc.setLineWidth(1.5);
						doc.line(
							data.cell.x,
							data.cell.y,
							data.cell.x,
							data.cell.y + data.cell.height
						);
					}
					if (data.column.index === 0) {
						doc.line(
							data.cell.x + data.cell.width,
							data.cell.y,
							data.cell.x + data.cell.width,
							data.cell.y + data.cell.height
						);
					}
				}
				if (
					data.section === 'body' &&
					data.column.index === 0 &&
					data.row.index === comparison.length - 1
				) {
					doc.setFillColor(0, 100, 106);
					doc.rect(data.cell.x - 9.7, data.cell.y + data.cell.height, 389.8, 20, 'F');
					doc.setTextColor(255, 255, 255);
					doc.setFontSize(8);
					doc.text(
						data.cell.x,
						data.cell.y + data.cell.height + 13,
						pdfLocalizations.phExplanation
					);
				}
			},
		});
		footer(doc);
	}

	// START: TYPE CHECK
	switch (type) {
		case TYPE_TABLE_IMAGE:
			await generateTableImage();
			break;
		case TYPE_TABLE:
			vertailuTiedot = JSON.parse(vertailuTiedot);
			await generateTable();
			break;
		default:
			break;
	}
	// END: TYPE CHECK

	// END: Extra content
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'pdf-download',
		product: title,
	});

	// Save the pdf
	doc.output('save', {
		filename: `${pdfLocalizations.pdfTitle}-${title}.pdf`,
	});

	// Output embed
	/*const embed = document.createElement("embed");
  embed.type = "application/pdf";
  embed.height = "1080";
  embed.width = "1920";
  embed.src = doc.output("datauristring");
  document.querySelector("main").appendChild(embed);*/
};

/**
 * @param {string} html
 */
function strip(html) {
	if (!html) return '';
	const doc = new DOMParser().parseFromString(html, 'text/html');
	const body = doc.body;
	// innerText keeps line breaks between block elements; textContent often does not
	if (typeof body.innerText === 'string' && body.innerText.length) {
		return body.innerText;
	}
	return body.textContent || '';
}

function normalizeTextForPdf(text) {
	return text
		.replace(/\u00a0/g, ' ')
		.replace(/\r\n?/g, '\n')
		.replace(/[ \t]+\n/g, '\n')
		.replace(/\n{3,}/g, '\n\n')
		.replace(/[ \t]{2,}/g, ' ')
		.trim();
}

function dedupeConsecutiveLines(lines) {
	let previousLine;

	return lines.filter((line) => {
		if (previousLine === line) {
			previousLine = line;
			return false;
		}

		previousLine = line;
		return true;
	});
}

function getTextLayout(doc, text, width, maxHeight) {
	const candidates = [
		{ fontSize: 10, lineHeightFactor: 1.15 },
		{ fontSize: 9.5, lineHeightFactor: 1.1 },
		{ fontSize: 9, lineHeightFactor: 1.05 },
		{ fontSize: 8.5, lineHeightFactor: 1 },
		{ fontSize: 8, lineHeightFactor: 1 },
		{ fontSize: 7.5, lineHeightFactor: 1 },
	];

	let fallbackLayout = {
		fontSize: candidates[candidates.length - 1].fontSize,
		lineHeightFactor: candidates[candidates.length - 1].lineHeightFactor,
		firstColumn: [],
		secondColumn: [],
	};

	for (const candidate of candidates) {
		doc.setFontSize(candidate.fontSize);
		const lineHeight = candidate.fontSize * candidate.lineHeightFactor;
		const singleWrapWidth = width * singleColumnTextWidthRatio;
		const splitTextSingle = dedupeConsecutiveLines(doc.splitTextToSize(text, singleWrapWidth));

		// Use one column when the full block fits; only split into two columns when needed.
		const singleColumnHeight = splitTextSingle.length * lineHeight;
		if (singleColumnHeight <= maxHeight) {
			const layout = {
				fontSize: candidate.fontSize,
				lineHeightFactor: candidate.lineHeightFactor,
				firstColumn: splitTextSingle,
				secondColumn: [],
			};
			fallbackLayout = layout;
			return layout;
		}

		const splitText = dedupeConsecutiveLines(doc.splitTextToSize(text, width));
		const halfLength = Math.ceil(splitText.length / 2);
		const columnHeight = halfLength * lineHeight;
		const layout = {
			fontSize: candidate.fontSize,
			lineHeightFactor: candidate.lineHeightFactor,
			firstColumn: splitText.slice(0, halfLength),
			secondColumn: splitText.slice(halfLength),
		};

		fallbackLayout = layout;

		if (columnHeight <= maxHeight) {
			return layout;
		}
	}

	return fallbackLayout;
}

function footer(doc) {
	// START: footer
	doc.setTextColor(58, 58, 58);
	doc.setFontSize(12);
	doc.setFont('AlbertSans', 'normal');
	doc.text(`${pdfLocalizations.footerStart} ${new Date().toLocaleDateString('sw')}`, 20, 616);
	doc.setFillColor(212, 102, 45);
	doc.rect(138, 609, 1, 9, 'F');
	doc.setTextColor(212, 102, 45);
	doc.text(pdfLocalizations.footerEnd, 144, 616);
	// END: footer
}

async function header(doc, tuoteImage, title, category, tuoteNro, language = 'fi') {
	let headerStart = 86;

	let titleFirst = title.split(' ')[0];
	let titleSecond = title.split(' ').slice(1).join(' ');
	let yellowLineHeight = 75;

	if (titleSecond === '') {
		titleSecond = titleFirst;
		titleFirst = '';
		yellowLineHeight = 52;
	}
	// START header
	// START: Yellow box - header
	doc.setFillColor(255, 214, 0);
	doc.rect(0, headerStart, 8, yellowLineHeight, 'F');
	// END: Yellow box - header

	// START: Hero Image
	const hero = document.createElement('img');
	hero.src = tuoteImage;
	const heroType = await getImageType(hero);
	if (heroType !== false) doc.addImage(hero, heroType, 220, 25, 227, 160);
	// END: Hero Image

	// START Logo - header
	// const logo = document.createElement("img");
	// logo.src = "/wp-content/themes/soilfood/assets/Soilfood-logo.png";
	// const logoType = await getImageType(logo);
	// This change has been made to fix WEBP not being correctly rendered in the PDF, so we are using a data URL.
	doc.addImage(
		'data:image/png;base64,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',
		'',
		15,
		35,
		58.5,
		32.4
	);
	// END: Logo - header

	headerStart += 12;

	// START: First text - header
	doc.setFont('Figtree', 'normal');
	doc.setFontSize(headerFontSize - 2);
	doc.setTextColor(0, 100, 106);
	doc.text(category, headerTextLeft, headerStart);
	// END: First text - header

	if (titleFirst !== '') headerStart += 20;

	// START: Product name text - header
	doc.setFont('Figtree', 'normal');
	doc.setTextColor(212, 102, 45);
	doc.setFontSize(headerLargeFontSize);
	doc.text(titleFirst, headerTextLeft, headerStart);
	if (titleSecond !== '' && titleFirst === '') headerStart += 18;
	else headerStart += 18;
	if (doc.getStringUnitWidth(titleSecond) * headerLargeFontSize > 215) {
		if (doc.getStringUnitWidth(titleSecond) * headerFontSize > 215) {
			doc.setFontSize(headerLargeFontSize - 12);
			doc.text(titleSecond, headerTextLeft, headerStart);
		} else {
			doc.setFontSize(headerFontSize);
			doc.text(titleSecond, headerTextLeft, headerStart);
		}
	} else {
		doc.setFontSize(headerFontSize + 2);
		doc.text(titleSecond, headerTextLeft, headerStart);
	}
	// END: Product name text - header

	headerStart += 16;

	// START: Product Number text - header
	doc.setTextColor(58, 58, 58);
	doc.setFont('AlbertSans', 'normal');
	doc.setFontSize(headerFontSize - 2);
	doc.text(pdfLocalizations.productNumber, headerTextLeft, headerStart);
	// END: Product Number text - header

	// START: Product Number - header
	doc.setFont('AlbertSans', 'bold');
	doc.setFontSize(headerFontSize - 2);
	let productNumberLeft = 75;
	if (language === 'sv') {
		productNumberLeft = 82;
	}
	doc.text(tuoteNro, productNumberLeft, headerStart);

	// END: Product Number - header
	// END: header
}

/**
 * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
 * images to fit into a certain area.
 *
 * @param {Number} srcWidth width of source image
 * @param {Number} srcHeight height of source image
 * @param {Number} maxWidth maximum available width
 * @param {Number} maxHeight maximum available height
 * @return {Object} { width, height }
 */

function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
	const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

	return { width: srcWidth * ratio, height: srcHeight * ratio };
}
